export const API_URl = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RECIPE_PER_PAGE = 10;
export const KEY = 'c8f473b6-44af-4659-bf45-4c9cce4d8742';
export const MODAL_SLOCE_SEC = 2.5;
